import React from "react";
import { useSelector } from "react-redux";

import styles from "./Seat.module.scss";

import { hallsSelector } from "../../../../redux/halls/selectors";
import { ISelectedHall } from "../../../../redux/halls/types";

import { ISeatProps } from "./types";

export const SeatItem = (props: ISeatProps) => {
  const { disabled = false, busyWithYou = false, data, onClickFunc } = props;
  const { id, date, time, price, hallTitle, startTime, finishTime } = data;
  const { selectedHalls } = useSelector(hallsSelector);
  const [selectStatus, setSelectStatus] = React.useState<boolean>(false);

  const thisSeatKeyName = `${time}-${id}-${date}`;

  React.useEffect(() => {
    Object.keys(selectedHalls).forEach((key) => {
      if (key === thisSeatKeyName) setSelectStatus(true);
    });
  }, [selectedHalls, thisSeatKeyName]);

  const handleClick = () => {
    if (disabled || busyWithYou) return;

    const now = Date.now();
    const selctedHall: ISelectedHall = {
      date,
      hallId: id!,
      hallTitle: hallTitle || "",
      price,
      time,
      unique: thisSeatKeyName,
      startTime: startTime,
      finishTime: finishTime,
      timestamp: now,
      addedAt: now,
    };

    if (selectStatus) {
      const cloneState = JSON.parse(JSON.stringify(selectedHalls));
      delete cloneState[thisSeatKeyName];
      onClickFunc(cloneState);
      setSelectStatus(false);
    } else {
      const cloneState = JSON.parse(JSON.stringify(selectedHalls));
      cloneState[thisSeatKeyName] = selctedHall;
      onClickFunc(cloneState);
      setSelectStatus(true);
    }
  };

  const isDisabled = disabled || busyWithYou;
  const isSelected = selectStatus || busyWithYou;

  return (
    <>
      <button
        disabled={isDisabled}
        className={
          isSelected 
            ? `${styles.item} ${styles.item_selected}` 
            : styles.item
        }
        onClick={handleClick}
      >
        <p>{time}</p>
        <p>{`${price} р/ч`}</p>
      </button>
    </>
  );
};
